
import { defineComponent, reactive, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'
import { ElMessage } from 'element-plus'
import {
  RangeSettingService
} from '@/views/dashboard/manage/software-usage/_components/range-setting/range-setting.service'
import SoftwareSelect from '@/views/dashboard/_components/software-select/software-select.vue'

export default defineComponent({
  components: { SoftwareSelect, EmptyData },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
  },

  setup (props, context) {
    const { t } = useI18n()
    const injector = useReflectiveInjector([RangeSettingService])
    const service = injector.get(RangeSettingService)

    const selectedNode = ref<Node & HTMLElement>()
    const isLoading = ref(false)
    const softwareChecked = ref<number[]>([])

    const searchParams = reactive({
      searchKey: '',
    })

    function updateSoftwareCheck () {
      service.getSoftConfig().then(response => {
        softwareChecked.value = response.data.map(v => v.soft_id)
      })
    }

    function handleConfirm () {
      if (!softwareChecked.value.length) {
        ElMessage.error(t('genuineSoftwareUsage.pleaseSetSoftwareFirst'))
        return
      }
      service.setSoftConfig({
        software_ids: softwareChecked.value
      }).then(() => {
        ElMessage.success(t('common.success'))
        context.emit('update')
        handleClose()
      })
    }

    function handleClose () {
      context.emit('update:modelValue', false)
    }

    watch(() => props.modelValue, (value) => {
      if (value) {
        updateSoftwareCheck()
      }
    })

    return {
      selectedNode,
      isLoading,
      softwareChecked,
      searchParams,
      handleClose,
      handleConfirm,
    }
  }
})
